'use client';

import { c as _c } from "react/compiler-runtime";
import { useFeatures } from '@udemy-v2/react-experimentation';
import { useInstructorCommunityBannerInfoByInstructorIdQuery } from '@/generated/graphql';

/**
 * Feature code gating the instructor community badges/ribbon/banner.
 * Monolith: ExpPlatform.get_feature_variant("instructor_community")
 */
export const FEATURE_INSTRUCTOR_COMMUNITY = 'instructor_community';

/**
 * Fetches an instructor's published community banner info via GraphQL
 * (instructorCommunityBannerInfoByInstructorId), gated behind the
 * instructor_community experiment. Returns null/false when the experiment
 * is disabled for the current viewer, or when the instructor has no
 * published community.
 */
export function useInstructorCommunityBannerInfo(instructorId) {
  const $ = _c(12);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = [FEATURE_INSTRUCTOR_COMMUNITY];
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const {
    featureVariantAssignments
  } = useFeatures(t0);
  let t1;
  if ($[1] !== featureVariantAssignments) {
    t1 = featureVariantAssignments.get(FEATURE_INSTRUCTOR_COMMUNITY)?.configuration?.enabled;
    $[1] = featureVariantAssignments;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const isExperimentEnabled = t1 === true;
  const t2 = String(instructorId);
  let t3;
  if ($[3] !== t2) {
    t3 = {
      instructorId: t2
    };
    $[3] = t2;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  const t4 = instructorId != null && isExperimentEnabled;
  let t5;
  if ($[5] !== t4) {
    t5 = {
      enabled: t4
    };
    $[5] = t4;
    $[6] = t5;
  } else {
    t5 = $[6];
  }
  const query = useInstructorCommunityBannerInfoByInstructorIdQuery(t3, t5);
  const bannerInfo = isExperimentEnabled ? query.data?.instructorCommunityBannerInfoByInstructorId ?? null : null;
  const t6 = isExperimentEnabled && bannerInfo != null;
  const t7 = isExperimentEnabled && query.isLoading;
  const t8 = (query.error ?? undefined) as Error | undefined;
  let t9;
  if ($[7] !== bannerInfo || $[8] !== t6 || $[9] !== t7 || $[10] !== t8) {
    t9 = {
      bannerInfo,
      hasCommunity: t6,
      isLoading: t7,
      error: t8
    };
    $[7] = bannerInfo;
    $[8] = t6;
    $[9] = t7;
    $[10] = t8;
    $[11] = t9;
  } else {
    t9 = $[11];
  }
  return t9;
}